
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home/Home/Home';
import Header from './components/Shared/Header/Header';
import Services from './components/Home/Services/Services';
import Checkout from './components/Checkout/Checkout';
import Login from './components/Auth/Login/Login';
import SignUp from './components/Auth/SignUp/SignUp';
import RequireAuth from './components/Auth/RequireAuth/RequireAuth';
import Footer from './components/Shared/Footer/Footer';
import AboutMe from './components/AboutMe/AboutMe';
import NotFound from './components/Shared/NotFound/NotFound';
import Blog from './components/Blog/Blog';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/services' element={<Services />}></Route>
        <Route path='/checkout' element={
          <RequireAuth>
            <Checkout />
          </RequireAuth>
        }></Route>
        <Route path='/login' element={<Login />}></Route>
        <Route path='/signup' element={<SignUp />}></Route>
        <Route path='/about-me' element={<AboutMe />}></Route>
        <Route path='/blogs' element={<Blog />}></Route>
        <Route path='*' element={<NotFound />}></Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
